import type { TokenResponseType } from './TokenResponseType';
import type { MailboxTypeHint } from 'owa-account-source-list-types';
import type { CredentialSecretType, CredentialParam } from './tokenRequestParams';

export type TokenParam = {
    name: string;
    value: string;
};

export type ClientTokenResponse = {
    token: string;
    expiresDur: number;
    tokenResponseType: TokenResponseType;
    additionalParameters?: TokenParam[];
};

export type AuthEmailResult = {
    email: string;
    typeHint: MailboxTypeHint;
    tokenResponse: ClientTokenResponse;
};

export enum CredentialRequestResult {
    Success = 'Success',
    Cancel = 'Cancel',
    InteractionRequired = 'InteractionRequired',
    TemporarilyUnavailable = 'TemporarilyUnavailable',
    ShuttingDown = 'ShuttingDown',
    ExtendedError = 'ExtendedError',
}

export type CredentialResponse = {
    credential: string;
    expiresDur: number;
    credentialRequestResult: CredentialRequestResult;
    credentialSecretType: CredentialSecretType;
    additionalParameters?: CredentialParam[];
};

export type CredentialEmailResult = {
    email: string;
    typeHint: MailboxTypeHint;
    uniqueId: string;
    credentialResponse: CredentialResponse;
};
